(() => {
  const root = document.querySelector("[data-tyre-finder]");
  if (!root) return;

  const mode = root.dataset.mode || "redirect";
  const collectionUrl = root.dataset.collectionUrl || "/collections/tyres";

  const searchInput = root.querySelector("[data-tyre-search]");
  const widthSel = root.querySelector("[data-tyre-width]");
  const profileSel = root.querySelector("[data-tyre-profile]");
  const rimSel = root.querySelector("[data-tyre-rim]");
  const posSel = root.querySelector("[data-tyre-position]");
  const btn = root.querySelector("[data-tyre-apply]");
  const resultsEl = root.querySelector("[data-tyre-results]");

  const parseSize = (raw) => {
    const t = (raw || "").toUpperCase().trim();
    const m = t.match(/(\d{2,3})\s*\/\s*(\d{2,3}).*?(\d{2})\b/);
    if (!m) return null;
    return { w: m[1], p: m[2], r: m[3] };
  };

  const buildUrl = () => {
    const params = new URLSearchParams();

    if (widthSel?.value) params.set("filter.p.m.custom.tyre_width", widthSel.value);
    if (profileSel?.value) params.set("filter.p.m.custom.tyre_profile", profileSel.value);
    if (rimSel?.value) params.set("filter.p.m.custom.tyre_rim", rimSel.value);
    if (posSel?.value) params.set("filter.p.m.custom.tyre_position", posSel.value);

    const q = params.toString();
    return q ? `${collectionUrl}?${q}` : collectionUrl;
  };

  const updateButtonState = () => {
    btn.disabled = !(
      widthSel?.value ||
      profileSel?.value ||
      rimSel?.value ||
      posSel?.value ||
      searchInput?.value.trim()
    );
  };

  const applySearchText = () => {
    const parsed = parseSize(searchInput.value);
    if (!parsed) return;
    widthSel.value = parsed.w;
    profileSel.value = parsed.p;
    rimSel.value = parsed.r;
  };

  const fetchInlineResults = async (url) => {
    if (!resultsEl) return;
    resultsEl.innerHTML = `<div style="opacity:.75;padding:10px 0;">Loading…</div>`;

    const res = await fetch(url, { credentials: "same-origin" });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const grid = doc.querySelector("#ProductGridContainer");
    resultsEl.innerHTML = "";
    resultsEl.appendChild(grid || document.createTextNode("No results"));
  };

  [widthSel, profileSel, rimSel, posSel].forEach(el =>
    el && el.addEventListener("change", updateButtonState)
  );

  searchInput?.addEventListener("input", () => {
    updateButtonState();
    if (parseSize(searchInput.value)) applySearchText();
  });

  btn?.addEventListener("click", async (e) => {
    e.preventDefault();
    const url = buildUrl();
    if (mode === "inline") await fetchInlineResults(url);
    else window.location.href = url;
  });

  updateButtonState();
})();
